var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgImgArquivo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65.5,
    r: 65.5,
    fill: "#F5F7FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3984_39990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 131
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 65.5C131 101.675 101.675 131 65.5 131C29.3253 131 0 101.675 0 65.5C0 29.3253 29.3253 0 65.5 0C101.675 0 131 29.3253 131 65.5Z",
    fill: "#617385"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3984_39990)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6223 64.0003L95.9242 131.843L96.7599 138.649C97.0291 140.842 95.4698 142.838 93.2772 143.107L34.7169 150.297C32.5243 150.566 30.5285 149.007 30.2593 146.815L21.2435 73.3871C21.1089 72.2907 21.8885 71.2928 22.9849 71.1582C22.9918 71.1574 22.9987 71.1566 23.0057 71.1558L41 68.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8607 63.8305C87.7669 63.1465 87.1364 62.6681 86.4525 62.7619C85.7685 62.8557 85.2901 63.4861 85.3839 64.1701L87.8607 63.8305ZM95.9242 131.843L97.1648 131.691C97.1641 131.685 97.1634 131.679 97.1626 131.673L95.9242 131.843ZM96.7599 138.649L98.0005 138.497L96.7599 138.649ZM93.2772 143.107L93.4295 144.348L93.2772 143.107ZM34.7169 150.297L34.8693 151.538L34.7169 150.297ZM30.2593 146.815L31.5 146.662L30.2593 146.815ZM23.0057 71.1558L23.145 72.398C23.1594 72.3964 23.1738 72.3945 23.1882 72.3924L23.0057 71.1558ZM41.1825 69.7366C41.8655 69.6358 42.3374 69.0004 42.2366 68.3175C42.1358 67.6345 41.5004 67.1626 40.8175 67.2634L41.1825 69.7366ZM85.3839 64.1701L94.6857 132.013L97.1626 131.673L87.8607 63.8305L85.3839 64.1701ZM94.6835 131.995L95.5192 138.802L98.0005 138.497L97.1648 131.691L94.6835 131.995ZM95.5192 138.802C95.7043 140.309 94.6323 141.681 93.1248 141.866L93.4295 144.348C96.3074 143.994 98.3539 141.375 98.0005 138.497L95.5192 138.802ZM93.1248 141.866L34.5646 149.057L34.8693 151.538L93.4295 144.348L93.1248 141.866ZM34.5646 149.057C33.0571 149.242 31.6851 148.17 31.5 146.662L29.0186 146.967C29.372 149.845 31.9914 151.891 34.8693 151.538L34.5646 149.057ZM31.5 146.662L22.4842 73.2347L20.0028 73.5394L29.0186 146.967L31.5 146.662ZM22.4842 73.2347C22.4337 72.8236 22.7261 72.4494 23.1372 72.3989L22.8325 69.9175C21.051 70.1363 19.7841 71.7578 20.0028 73.5394L22.4842 73.2347ZM23.1372 72.3989C23.1398 72.3986 23.1424 72.3983 23.145 72.398L22.8663 69.9136C22.855 69.9148 22.8438 69.9162 22.8325 69.9175L23.1372 72.3989ZM23.1882 72.3924L41.1825 69.7366L40.8175 67.2634L22.8231 69.9192L23.1882 72.3924Z",
    fill: "#E0E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0909 68.2691L92.5104 129.753L93.2678 135.921C93.5118 137.908 92.1178 139.714 90.1542 139.956L37.7122 146.395C35.7486 146.636 33.959 145.22 33.715 143.233L25.565 76.8567C25.4304 75.7603 26.21 74.7625 27.3064 74.6278L33.794 73.8313",
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8726 54C40.8726 52.4812 42.1038 51.25 43.6226 51.25H89.1793C89.9084 51.25 90.6076 51.5395 91.1233 52.0549L104.566 65.4898C105.083 66.0056 105.373 66.7053 105.373 67.4349V130C105.373 131.519 104.141 132.75 102.623 132.75H43.6226C42.1038 132.75 40.8726 131.519 40.8726 130V54Z",
    fill: "white",
    stroke: "#E0E6EB",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6226 52.4028V64C89.6226 65.6569 90.9657 67 92.6226 67H105",
    stroke: "#E0E6EB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9507 67H76.9507M50.9507 79H93.9507M50.9507 92H93.9507M50.9507 105H93.9507M50.9507 118H76.9507",
    stroke: "#E0E6EB",
    strokeWidth: 2.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgImgArquivo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/img-arquivo.fe627c3f.svg";
export { ForwardRef as ReactComponent };